export default __webpack_public_path__ + "static/media/crick.05e16069.jpeg";